<template>
    <div class="formul" v-bind:class="{'notedited': !editedpest['edit'], 'collapsible-body ': editedpest['id']}">
        <div class="row" style="width: 100%;">
            <div class="col s3">
                <template v-if="editedpest.image != null && editedpest.image != undefined">
                    <v-lazy-image v-bind:src="editedpest.image" src-placeholder="/nofoto.png" width="200" />
                </template>
                <input type="file" id="input" @change="setImageFile(editedpest, $event.target.name, $event.target.files)" v-if="editedpest.edit">
            </div>
            <div class="col s5 selectorignored input-field ">
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.name')}}</div>
                    <div class="input-field inline col s8"><input type="text" :placeholder="$t('pests.name')" v-model="editedpest.name" :disabled="editedpest.edit == false" /></div>
                </div>
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.name_sp')}}</div>
                    <div class="input-field inline col s8"><input type="text" :placeholder="$t('pests.name_sp')" v-model="editedpest.name_sp" :disabled="editedpest.edit == false" /></div>
                </div>
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.existence')}}</div>
                    <div class="input-field inline col s8"><input type="text" :placeholder="$t('pests.existence_placeholder')" v-model="editedpest.origins" :disabled="editedpest.edit == false" /></div>
                </div>
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.nuissance')}}</div>
                    <div class="input-field inline col s3">
                        <select v-model="editedpest.nuissance" :disabled="editedpest.edit == false">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </select>
                    </div>
                    <div class="col s5">
                        <label>
                            <input type="checkbox" name="endangered" v-model="editedpest.endangered" :disabled="editedpest.edit == false" />
                            <span style="color: black;">{{$t('pests.endangered')}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="col s3 selectorignored input-field ">
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.row')}}</div>
                    <div class="input-field inline col s8"><input type="text" :placeholder="$t('pests.row')" v-model="editedpest.row" :disabled="editedpest.edit == false" /></div>
                </div>
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.group')}}</div>
                    <div class="input-field inline col s8" style="padding-right: 5px;margin-right: 0px;">
                        <vue-tags-input :tags="pesttags" v-model="pesttagstext" v-bind:autocomplete-items="filteredItems" :separators="[',']" @tags-changed="newTags =>  setTags(newTags)"></vue-tags-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col s4 rightlabel">{{$t('pests.category')}}</div>
                    <div class="input-field inline col s8" style="padding-right: 5px;margin-right: 0px;"><select v-model="editedpest.group_id" :disabled="editedpest.edit == false">
                            <option v-for="group in pest_groups" :value="group.id">{{group.name}}</option>
                        </select>{{errors.group_id}}</div>
                </div>
            </div>
            <modal v-if="editedpest.removable" :question="$t('pests.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="pestRemoveQuestion" v-on:onConfirm="removeeditedPest(editedpest)" />
        </div>
        <div class="row" style="width: 100%;">
            <div class="col s6 input-field">
                <div class="label">{{$t('pests.description')}}</div>
                <editable v-model="editedpest.description" :placeholder="$t('pests.description')" :disabled="!editedpest.edit" />
                <!-- <contenteditable v-model="editedpest.description"/> -->
            </div>
            <div class="col s6 input-field">
                <div class="label">{{$t('pests.living_places')}}</div>
                <editable v-model="editedpest.living_places" :placeholder="$t('pests.living_places_placeholder')" :disabled="editedpest.edit == false" />
                <div class="label" style="padding-top: 15px;">{{$t('pests.products')}}</div>
                <editable v-model="editedpest.products" :placeholder="$t('pests.products')" :disabled="editedpest.edit == false" />
            </div>
        </div>
        <div class="row" style="margin-top: 16px;">
            <div class="col offset-l10 s4 l2" v-if="editedpest.edit == false && editedpest.editable" style="text-align: right;"><a class="waves-effect waves-light btn-large emptygreen" v-on:click="editPest(editedpest)">{{$t('menu.buttons.edit')}}</a></div>
            <div class="col  offset-l8 s4 l2" v-if="editedpest.edit" style="text-align: right;"><a class="waves-effect waves-light btn-large cancelbutton" v-on:click="unEditPest(editedpest)"> {{$t('menu.buttons.cancel_changes')}}</a></div>
            <div class="col l2 s4" v-if="editedpest.edit" style="text-align: right; ">
                <a style="width: 100%;" class="waves-effect waves-light btn-large emptygreen" v-on:click="savePest(editedpest)">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import * as DOMPurify from 'dompurify';
export default {
    data: function() {
        return {
            order: 1,
            orderby: 'number',
            customers: [],
            saving: false,
            pesttagstext: "",
            old_pest: {},
            editedpest: {},
            errors: {group_id: undefined}
        }
    },
    props: { pest: Object, index: Number, pest_groups: Array, peststagsgroups: Array, peststagsgroupsstring: Array, dev_types: Array },
    created() {
        this.pesttags = _.map(this.pest.tags, tag => {
            return { text: tag };
        })
        this.pesttagstext = ""
        if (_.isUndefined(this.pest.media)) {
            this.pest.media = []
            this.pest.media.push({ "image": "" });
        }

    },
    mounted: function() {
        this.editedpest = _.cloneDeep(this.pest);
        if(_.isUndefined( this.editedpest.edit)) {
            this.editedpest.edit = false;
        }
    },
    methods: {
        removeeditedPest: function(pest){
            this.$emit('removePest', pest);
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 1) {
                    this.order = 0
                } else if (this.order == 0) {
                    this.order = 1
                }

            } else {
                this.orderby = order;
            }
        },
        convertToPlain: function(html){
            return _.trim(DOMPurify.sanitize(html, {ALLOWED_TAGS: ['%text', 'div']}).replaceAll('<div>','').replaceAll('</div>','\n').replaceAll('&nbsp;', " "));
        },
        setImageFile: async function(doc, name, file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
            const result = await toBase64(file[0]).catch(e => Error(e));
            if (result instanceof Error) {
                console.log('Error: ', result.message);
                return;
            }
            doc.image = result;
            if(doc.media.length == 0) doc.media.push({image: ""});
            doc.media[0].image = file[0];
            this.$forceUpdate();
        },
        editPest: function(pest) {
            this.old_pest = _.cloneDeep(pest);
            pest.edit = true;
            this.$forceUpdate();
        },
        unEditPest: function(pest) {
            Object.assign(pest, this.old_pest)
            if (pest.id) {
                pest.edit = false;
            } else {
                this.$emit('cancelPest', pest);
            }
            this.$forceUpdate();
        },
        setTags: function(newTags) {
            this.pest.tags = _.map(newTags, "text")
            this.pesttagstext = ""
        },
        isValid(pest){
            if(_.isUndefined(pest.group_id)){
                this.errors['group_id'] = this.$t('pests.errors.group_id')
                return false;
            }
            this.$forceUpdate();
            return true;
        },
        savePest: function(pest) {
            if(this.isValid(pest)){
                this.saving = true
                const formData = new FormData();
                var htmlparams = ["description", "origins", "living_places", "products"];
                // formData.append('pest[tag_list]', pest.tags.join());
                for (var key of Object.keys(pest)) {
                    if (_.isNull(pest[key]) == false) {
                        if(htmlparams.indexOf(key) > -1){
                            formData.append('pest[' + key + ']', this.convertToPlain(pest[key]));
                        }else{
                            formData.append('pest[' + key + ']', pest[key]);
                        }
                    }
                }
                var i = 0;
                for (var reco of pest.media) {
                    if (pest.media[0].image != "") {
                        for (var key of Object.keys(reco)) {
                            formData.append('pest[media_attributes][' + i + '][' + key + ']', reco[key]);
                        }
                    }
                    if (reco.destroy) {
                        formData.append('pest[media_attributes][' + i + '][_destroy]', true);
                    }
                    i += 1;
                }
                formData.append('pest[tag_list]',this.pest.tags);
                
                if (_.isUndefined(pest.id)) {
    
                    axios.post('/pests.json', formData).then(response => {
                        this.editedpest.id = response.data.id;
                        this.editedpest.edit = false;
                        this.saving = false;
                        var pest = response.data;
                        pest.tags = _.map(pest.tag_list, 'name');
                        this.$emit('addPest', pest)
                        this.$forceUpdate();
                    });
                } else {
                    axios.put('/pests/' + pest.id + '.json', formData).then(response => {
                        this.editedpest.edit = false;
                        this.saving = false;
                        var pest = response.data;
                        pest.tags = _.map(pest.tag_list, 'name');
                        this.$emit('updatePest', pest)
                        this.$forceUpdate();
                    });
                }
            }
        },
        removePest: function(pest) {
            this.$emit('removePest', pest);
        }
    },
    computed: {
        filteredItems: function() {
            return this.peststagsgroupsstring.filter(i => {
                return (i.text || "").toLowerCase().indexOf(this.pesttagstext.toLowerCase()) !== -1;
            });
        },
        hasRemoveListener() {
            return this.$listeners && this.$listeners.removePest
        }
    }
}
</script>
<style scoped>
textarea {
    resize: both !important;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}



.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #FFFFFF !important;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.row {
    margin-bottom: 0px;
}

.row>.input-field {
    margin-top: 0px;
    margin-bottom: 5px;
}

.rightlabel {
    text-align: right;
    line-height: 2;
    text-transform: uppercase;
}

.label {
    text-transform: uppercase;
}

.solidgreen {
    background-color: #00CC66 !important;
}

.preloader-wrapper {
    margin-top: 10px !important;
}

.emptygreen {
    background-color: #FFF !important;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;

}

.btn-small {
    color: black;
    border-radius: 8px;
}

.solidgreen {
    background-color: #00CC66 !important;
}

.vue-tags-input .ti-input {
    border-radius: 8px !important;
    padding-bottom: 5px !important;
    padding-top: 5px !important;
}

.vue-tags-input {}

input[type="file"] {
    max-width: 100%;
}
</style>